import CrudRequest from '@/app/arch/components/crud/CrudRequest';
import httpService from '@/app/arch/services/HttpService';

export default class EstablishmentService extends CrudRequest {
  static baseUrl() {
    return 'account/establishment';
  }

  static update(payload) {
    return httpService.patch(
      `${this.baseUrl()}/taxas`,
      payload,
    );
  }

  static listMcc() {
    return httpService.get(
      `${this.baseUrl()}/mcc`,
    );
  }
}
